
























import {defineComponent} from '@vue/composition-api'
import {dateFilters} from "@/edinet/libs/dates"
import {enumFilters} from '@/edinet/types'

export default defineComponent({
  name: 'ObjectTable',
  props: ['obj', 'showIndex', 'showHeader', 'excludeKeys'],
  computed: {
    // eslint-disable-next-line
    filteredObj: function(): any {
      const obj = this.obj
      let keys: string[] = Object.keys(obj)
      if (this.excludeKeys) {
        keys = keys.filter((x: string) => !this.excludeKeys.includes(x))
      }
      // eslint-disable-next-line
      const filtered = keys.reduce((acc: any, key: string) => {
        acc[key] = obj[key]
        return acc;
      }, {});
      return filtered
    }
  },
  filters: {
    ...dateFilters,
    ...enumFilters
  }
})
